import { defineMessages } from 'react-intl';

export const messages: {
	allApps: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	groupLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	allApps: {
		id: 'search-page.search-page-relay.filters.refresh-filter-row.apps.allApps',
		defaultMessage: 'All apps',
		description:
			'Label for the filter pill that clears the app filter and shows results from every app.',
	},
	groupLabel: {
		id: 'search-page.search-page-relay.filters.refresh-filter-row.apps.groupLabel',
		defaultMessage: 'Filter by app',
		description:
			'Accessible name for the group of app filter buttons at the start of the search filter row.',
	},
});
